import { dispatch } from "../store/store";
import {
  getClinicalServiceByClinicalServiceIdData,
  getClinicalServiceData,
  getClinicalServiceFromOrbitData,
  getTitanPatientData,
  getTitanPatientPdsData,
  getFollowUpByServiceIdAndServiceTypeData,
  getPharmacyIdForOrbitUserData,
  getVoiceJWTData,
  getTimelineData,
  addNmsData,
  updatePrivateServiceData,
  searchDrugData,
  searchPatientData,
  addFollowUpData,
  setIsNmsLoading,
  setIsNmsPatientLoading,
  setIsNmsTimelineLoading,
  setNmsOrbit,
  setIsPatientNmsTelephoneLoading,
  setIsNmsPrescriptionLoading,
  setIsServiceNotesLoading,
  setClinicalServiceData,
  setPatientData,
  setService,
  setPatientName,
  setPharmacyNms,
  setPharmacyId,
  setClinicalpatientId,
  setClinicalServiceId,
  setArrayImg,
  setIsPrescriptionImages,
  setStepNoNms,
  setstageNoNms,
  setNmsModelNms,
  setvalueNms,
  setIsShowEndCall,
  setIsCalling,
  setIsFollowupDescription,
  setIsFollowupDate,
  setVoiceJWTToken,
  addTimelineData,
  addTimelineItemData,
  setTimelineElements,
  setPatientNMSData,
  getRecordingByConversationIdData,
  saveTotalAttemptsData,
  addServiceNotesData,
  getServiceNotesData,
  getPatientByTelephoneAndStageIndexData,
  updateTotalAttemptsByClinicalServiceIdData,
  skipOrbitByClinicalServiceIdData,
  backOrbitByClinicalServiceIdData,
  parkOrbitByClinicalServiceIdData,
  setRescheduleComponent,
  setPatientDeclined,
  setSkipNMSModal,
  setDeclineNMSModal,
  setMultipleNumbersNMSModal,
  setDeclineComments,
  setFollowUpcomments,
  getTotalSkipsData,
  setGroupedPatientWarning,
  setPatientCountData,
  setSkipCountData,
  setShowNMSNotComplete,
  setTempClinicalServiceId,
  setOpenCallScreenDialogData,
  setCallStartTimeData,
  setCallEndTimeData,
  setIsFollowUpControlData,
  setTempVaccineTemplatesData,
  setEditedPreferredContact,
  getPatientPhoneNumberData,
  setResponseDTOStagesData,
  getPrescriptionImagesByIncomingIdsData,
  getTravelInformationData,
  getPharmacyProductsData,
  getDrugSearchData,
  getDrugInformationData,
  getProductByPrescriptionIdData,
  setIsDrugsData,
  setIsDrugsAboutData,
  getCompletedTravelInformationData,
  getCompletedClinicalServiceData,
  generatePrescription,
  setSelectedDrugsData,
  setShowVaccineBasketData,
  setSelectedVaccineDoseData,
  setSelectedVaccineTitleData,
  setShowVaccinePrescriptionData,
  addVaccineDosageData,
  getVaccineInfoData,
  setIsConsentData,
  setTelPatientCurrentIndexData,
  getDrugBySearchData,
  setDrugSummaryData,
  addPrescriptionData,
  getPrescriptionByPatientIdData,
  addVaccinationData,
  getCompanyVaccineByCompanyIdData,
  setIsInterventionDate,
} from "../features/NmsServiceSlice/NmsServiceSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "nmsService";

// #region State Setters

export const setCurrentArrayImg = (images) => {
  dispatch(setArrayImg(images));
};

export const setCurrentIsNmsLoading = (value) => {
  dispatch(setIsNmsLoading(value));
};
export const setCurrentIsNmsPatientLoading = (value) => {
  dispatch(setIsNmsPatientLoading(value));
};
export const setCurrentIsNmsTimelineLoading = (value) => {
  dispatch(setIsNmsTimelineLoading(value));
};
export const setCurrentNmsOrbit = (data) => {
  dispatch(setNmsOrbit(data));
};
export const setCurrentIsPatientNmsTelephoneLoading = (value) => {
  dispatch(setIsPatientNmsTelephoneLoading(value));
};
export const setCurrentIsNmsPrescriptionLoading = (value) => {
  dispatch(setIsNmsPrescriptionLoading(value));
};
export const setCurrentIsServiceNotesLoading = (value) => {
  dispatch(setIsServiceNotesLoading(value));
};

export const setCurrentPatientName = (value) => {
  dispatch(setPatientName(value));
};

export const setCurrentStepNoNms = (value) => {
  dispatch(setStepNoNms(value));
};
export const setCurrentstageNoNms = (value) => {
  dispatch(setstageNoNms(value));
};
export const setCurrentNmsModel = (value) => {
  dispatch(setNmsModelNms({ ...value }));
};
export const setCurrentvalueNms = (value) => {
  dispatch(setvalueNms(value));
};

export const setCurrentIsCalling = (value) => {
  dispatch(setIsCalling(value));
};
export const setCurrentVoiceJWTToken = (value) => {
  dispatch(setVoiceJWTToken(value));
};
export const setFollowupDescription = (description) => {
  dispatch(setIsFollowupDescription(description));
};
export const setFollowupDate = (date) => {
  dispatch(setIsFollowupDate(date));
};
export const setInterventionDate = (date) => {
  dispatch(setIsInterventionDate(date));
};
export const setCurrentTimelineElements = (value) => {
  dispatch(setTimelineElements(value));
};
export const setCurrentPatientNMSData = (value) => {
  dispatch(setPatientNMSData(value));
};
export const setCurrentRescheduleComponent = (value) => {
  dispatch(setRescheduleComponent(value));
};
export const setCurrentPatientDeclined = (value) => {
  dispatch(setPatientDeclined(value));
};
export const setCurrentSkipNMSModal = (value) => {
  dispatch(setSkipNMSModal(value));
};
export const setCurrentDeclineNMSModal = (value) => {
  dispatch(setDeclineNMSModal(value));
};
export const setCurrentMultipleNumbersNMSModal = (value) => {
  dispatch(setMultipleNumbersNMSModal(value));
};
export const setCurrentDeclineComments = (value) => {
  dispatch(setDeclineComments(value));
};
export const setCurrentFollowUpcomments = (value) => {
  dispatch(setFollowUpcomments(value));
};
export const setCurrentGroupedPatientWarning = (value) => {
  dispatch(setGroupedPatientWarning(value));
};
export const setCurrentPatientCountData = (value) => {
  dispatch(setPatientCountData(value));
};
export const setCurrentSkipCountData = (value) => {
  dispatch(setSkipCountData(value));
};
export const setTelPatientCurrentIndex = (value) => {
  dispatch(setTelPatientCurrentIndexData(value));
};
export const setCurrentShowNMSNotComplete = (value) => {
  dispatch(setShowNMSNotComplete(value));
};
export const setCurrentTempClinicalServiceId = (value) => {
  dispatch(setTempClinicalServiceId(value));
};
export const setOpenCallScreenDialog = (value) => {
  dispatch(setOpenCallScreenDialogData(value));
};
export const setIsFollowUpControl = (value) => {
  dispatch(setIsFollowUpControlData(value));
};
export const setIsConsent = (value) => {
  dispatch(setIsConsentData(value));
};
export const setCallStartTime = (value) => {
  dispatch(setCallStartTimeData(value));
};
export const setCallEndTime = (value) => {
  dispatch(setCallEndTimeData(value));
};
export const setCurrentEditedPreferredContact = (value) => {
  dispatch(setEditedPreferredContact(value));
};
export const setCurrentResponseDTOStagesData = (value) => {
  dispatch(setResponseDTOStagesData(value));
};
export const setDrugsData = (value) => {
  dispatch(setIsDrugsData(value));
};
export const setDrugsAboutData = (value) => {
  dispatch(setIsDrugsAboutData(value));
};

export const setselectedDrugs = (value) => {
  dispatch(setSelectedDrugsData(value));
};
export const setShowVaccineBasket = (value) => {
  dispatch(setShowVaccineBasketData(value));
};
export const setSelectedVaccineDose = (value) => {
  dispatch(setSelectedVaccineDoseData(value));
};
export const setSelectedVaccineTitle = (value) => {
  dispatch(setSelectedVaccineTitleData(value));
};
export const setShowVaccinePrescription = (value) => {
  dispatch(setShowVaccinePrescriptionData(value));
};

export const setDrugSummary = (data) => {
  dispatch(setDrugSummaryData(data));
};

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getClinicalServiceByClinicalServiceId = async (
  clinicalServiceId,
) => {
  let result = null;
  try {
    result = await dispatch(
      getClinicalServiceByClinicalServiceIdData({
        clinicalServiceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, clinicalServiceId);
    result = null;
  }
  return result;
};

export const getClinicalServiceFromOrbit = async (params) => {
  let result = null;
  try {
    result = await dispatch(getClinicalServiceFromOrbitData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const getPharmacyIdForOrbitUser = async () => {
  let result = [];
  try {
    result = await dispatch(getPharmacyIdForOrbitUserData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const getTitanPatient = async (params) => {
  let result = [];
  try {
    result = await dispatch(getTitanPatientData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = [];
  }
  return result;
};

export const getTitanPatientPds = async (params) => {
  let result = null;
  try {
    result = await dispatch(getTitanPatientPdsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const getVoiceJWT = async (params) => {
  let result = null;
  try {
    result = await dispatch(getVoiceJWTData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const getFollowUpByServiceIdAndServiceType = async (
  serviceId,
  serviceType,
  stageNo,
) => {
  let result = [];
  try {
    result = await dispatch(
      getFollowUpByServiceIdAndServiceTypeData({
        serviceId,
        serviceType,
        stageNo,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const getPatientByTelephoneAndStageIndexResult = async (
  telephone,
  value,
  serviceId,
  userSessionId,
  isOrbitUser,
) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientByTelephoneAndStageIndexData({
        telephone,
        value,
        serviceId,
        userSessionId,
        isOrbitUser,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const addNms = async (data, isOrbitUser) => {
  let result = null;
  try {
    result = await dispatch(addNmsData({ data, isOrbitUser })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updatePrivateService = async (
  data,
  isOrbitUser,
  isAddPrescription,
) => {
  let result = null;
  try {
    result = await dispatch(
      updatePrivateServiceData({ data, isOrbitUser, isAddPrescription }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const addFollowUp = async (data) => {
  let result = null;
  try {
    result = await dispatch(addFollowUpData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const addTimelineItem = async (data) => {
  let result = null;
  try {
    result = await dispatch(addTimelineItemData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getTimeline = async (params) => {
  let result = null;
  try {
    result = await dispatch(getTimelineData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const saveTotalAttempts = async (params) => {
  let result = null;
  try {
    result = await dispatch(saveTotalAttemptsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const updateTotalAttemptsByClinicalServiceId = async (params) => {
  let result = null;
  try {
    result = await dispatch(
      updateTotalAttemptsByClinicalServiceIdData(params),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const skipOrbitByClinicalServiceId = async (params) => {
  let result = null;
  try {
    result = await dispatch(skipOrbitByClinicalServiceIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const getTotalSkips = async (params) => {
  let result = null;
  try {
    result = await dispatch(getTotalSkipsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const backOrbitByClinicalServiceId = async (params) => {
  let result = null;
  try {
    result = await dispatch(backOrbitByClinicalServiceIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const parkOrbitByClinicalServiceId = async (params) => {
  let result = null;
  try {
    result = await dispatch(parkOrbitByClinicalServiceIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const addServiceNotes = async (data) => {
  let result = null;
  try {
    result = await dispatch(addServiceNotesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getServiceNotes = async (params) => {
  let result = [];
  try {
    result = await dispatch(getServiceNotesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = [];
  }
  return result;
};
export const getPatientPhoneNumber = async (params) => {
  let result = [];
  try {
    result = await dispatch(getPatientPhoneNumberData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = [];
  }
  return result;
};

export const getPrescriptionImagesByIncomingIds = async (param) => {
  let result = null;
  try {
    result = await dispatch(
      getPrescriptionImagesByIncomingIdsData(param),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, param);
    result = null;
  }
  return result;
};
export const getTravelInformation = async (params) => {
  let result = null;
  try {
    result = await dispatch(getTravelInformationData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const getDrugInformation = async (prescribedItemId) => {
  let result = null;
  try {
    result = await dispatch(getDrugInformationData(prescribedItemId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, prescribedItemId);

    result = null;
  }
  return result;
};
export const getProductByPrescriptionId = async (prescribedItemId) => {
  let result = null;
  try {
    result = await dispatch(
      getProductByPrescriptionIdData(prescribedItemId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, prescribedItemId);

    result = null;
  }
  return result;
};
export const getCompletedTravelInformation = async (params) => {
  let result = null;
  try {
    result = await dispatch(getCompletedTravelInformationData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const getCompletedClinicalService = async (params) => {
  let result = null;
  try {
    result = await dispatch(getCompletedClinicalServiceData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const generatePrescriptionService = async (data) => {
  let result = null;
  try {
    result = await dispatch(generatePrescription({ data })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const getPharmacyProducts = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPharmacyProductsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const addVaccineDosage = async (params) => {
  let result = null;
  try {
    result = await dispatch(addVaccineDosageData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const getVaccineInfo = async (params) => {
  let result = null;
  try {
    result = await dispatch(getVaccineInfoData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const getDrugBySearch = async (data) => {
  let result = null;
  try {
    result = await dispatch(getDrugBySearchData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const addPrescription = async (params) => {
  let result = null;
  try {
    result = await dispatch(addPrescriptionData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};
export const getPrescriptionByPatientId = async (patientId) => {
  let result = null;
  try {
    result = await dispatch(getPrescriptionByPatientIdData(patientId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = null;
  }
  return result;
};
export const addVaccination = async (data) => {
  let result = null;
  try {
    result = await dispatch(addVaccinationData({ data })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const getCompanyVaccineByCompanyId = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getCompanyVaccineByCompanyIdData(companyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};

// #endregion
